import React, { memo, useReducer, useRef } from 'react';
import { Space } from '@redlink/components/atoms';
import { TextInput, Button } from '@redlink/components/molecules';
import { useLocale } from '@redlink/assets/locale';
import { useValues } from '@redlink/assets/values';
import { useMutation, signUpWithPhoneNumberQuery } from '@redlink/services';
import { initialState, reducer, types } from './store';
import { AuthPageContainer } from './authPageContainer';
import { createUseStyle } from '@redlink/assets/styles';
import { useNavigation, StackActions } from '@react-navigation/native';

export const RegisterWithPhonePage = memo(({ navigation }) => {
  const { dictionary } = useLocale();
  const { routes } = useValues();
  const authContainerRef = useRef(null);
  const { styles } = useStyle();
  const { dispatch: navigationDispatch } = useNavigation();

  const [{ phoneNumber }, dispatch] = useReducer(reducer, initialState);

  const [signIn, { loading: signInIsBusy }] = useMutation(
    signUpWithPhoneNumberQuery,
    {
      done: () =>
        navigationDispatch(
          StackActions.replace(routes.verifyPhone.key, { phoneNumber })
        ),
    }
  );

  return (
    <AuthPageContainer
      ref={authContainerRef}
      isBusy={signInIsBusy}
      title={dictionary.login}
    >
      <TextInput
        require
        value={phoneNumber}
        onChangeText={(value) =>
          dispatch({ type: types.SET_PHONE_NUMBER, payload: value })
        }
        title={dictionary.enterPhoneNumber}
        placeholder="09*********"
        keyboardType="numeric"
      />
      <Space />
      <Button
        style={styles.formActionContainer}
        title={dictionary.getPhoneVerificationCode}
        variant="primary"
        onPress={() => {
          signIn({
            phoneNumber,
          });
        }}
      />
    </AuthPageContainer>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  formActionContainer: {
    flex: 1,
    minHeight: 50,
  },
}));
